import { wrapWithErrorHandling } from '../helpers/wrapWithErrorHandling'
import { JeevesGetProductPricing } from './pricing/getProductPricing'

export const jeeves = wrapWithErrorHandling({
  getProductPricing: JeevesGetProductPricing,
})
